import config from "@/config"
import http from "@/utils/request"
// import tool from "@/utils/tool"
export default {
  businessModule: {
    list: {
      url: `${config.API_URL}/notify/businessModule`,
      name: "业务模块",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      changeStatus: async function (data) {
        return await http.post(`${this.url}/changeStatus`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      }
    }
  },
  eventDefinition: {
    list: {
      url: `${config.API_URL}/notify/eventDefinition`,
      name: "通知事件",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      update: async function (data) {
        return await http.post(`${this.url}/update`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      detail: async function (data) {
        return await http.post(`${this.url}/detail`, data)
      },
      changeStatus: async function (data) {
        return await http.post(`${this.url}/changeStatus`, data)
      }
    }
  },
  audience: {
    list: {
      url: `${config.API_URL}/audience`,
      name: "受众管理",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      update: async function (data) {
        return await http.post(`${this.url}/update`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      detail: async function (data) {
        return await http.post(`${this.url}/detail`, data)
      },
      changeStatus: async function (data) {
        return await http.post(`${this.url}/changeIsEnabled`, data)
      },
      getTag: async function (data) {
        return await http.post(`${this.url}/tag/${data.sourceModule}`, data)
      }
    }
  },
  template: {
    list: {
      url: `${config.API_URL}/notify/notificationTemplate`,
      name: "通知模板管理",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      update: async function (data) {
        return await http.post(`${this.url}/update`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      detail: async function (data) {
        return await http.post(`${this.url}/detail`, data)
      },
      changeStatus: async function (data) {
        return await http.post(`${this.url}/changeStatus`, data)
      }
    }
  },
  // channel: {
  //   list: {
  //     url: `${config.API_URL}/channel`,
  //     name: "渠道配置",
  //     get: async function (params) {
  //       return await http.get(`${this.url}/list`, params)
  //     },
  //     submit: async function (data) {
  //       return await http.post(`${this.url}/create`, data)
  //     },
  //     del: async function (data) {
  //       return await http.post(`${this.url}/delete`, data)
  //     },
  //     updataStatus: async function (data) {
  //       return await http.post(`${this.url}/updataStatus`, data)
  //     }
  //   }
  // },
  config: {
    list: {
      url: `${config.API_URL}/notify/notificationConfig`,
      name: "通知配置",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      update: async function (data) {
        return await http.post(`${this.url}/update`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      detail: async function (data) {
        return await http.post(`${this.url}/detail`, data)
      },
      changeStatus: async function (data) {
        return await http.post(`${this.url}/changeStatus`, data)
      },
      sendNotifyByConfig: async function (data) {
        return await http.post(`${this.url}/sendNotifyByConfig`, data)
      }
    }
  },
  message: {
    list: {
      url: `${config.API_URL}/notify/notificationMessage`,
      name: "通知消息记录",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      update: async function (data) {
        return await http.post(`${this.url}/update`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      detail: async function (data) {
        return await http.post(`${this.url}/detail`, data)
      },
      changeStatus: async function (data) {
        return await http.post(`${this.url}/changeStatus`, data)
      }
    }
  },
  userMessage: {
    list: {
      url: `${config.API_URL}/notify/userNotificationMessage`,
      name: "用户通知记录",
      get: async function (params) {
        return await http.get(`${this.url}/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      update: async function (data) {
        return await http.post(`${this.url}/update`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      detail: async function (data) {
        return await http.post(`${this.url}/detail`, data)
      },
      changeStatus: async function (data) {
        return await http.post(`${this.url}/changeStatus`, data)
      },
      //==================用户通知信息==================
      userList: async function (params) {
        return await http.get(`${this.url}/user/list`, params)
      },
      userBatchRead: async function (data) {
        return await http.post(`${this.url}/user/batchRead`, data)
      },
      userAllRead: async function (data) {
        return await http.post(`${this.url}/user/allRead`, data)
      },
      removeSelectMsg: async function (data) {
        return await http.post(`${this.url}/user/removeSelectMsg`, data)
      }
    }
  }
}
